import React from 'react';
import InnerPage from './innerPage.jsx';
import './style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../../components/header';
import Header2 from '../../components/header2';
import Footer from '../../components/footer';

const MembersPublic = () => {
  return (
    <div>
      <Header2 />
      <Header />
      <div className="bg-space" />
      <section className="inner-page">
        <InnerPage />
      </section>
      <Footer />
    </div>
  );
};

export default MembersPublic;